/**
 * Data layer for `real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s`. Thin typed fetch wrappers over /api/v1/real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSResponse {
	count: number;
	items: RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRow[];
}

export interface CreateRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSResponse>(res);
}

export async function create(body: CreateRealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSBody): Promise<RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<RealTimeAnomalyMlCrDropFraudSpikeDepositDropWithSRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys = {
	all: ["real-time-anomaly-ml-cr-drop-fraud-spike-deposit-drop-with-s"] as const,
	list: () => [...realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys.all] as const,
	detail: (id: string) => [...realTimeAnomalyMlCrDropFraudSpikeDepositDropWithSQueryKeys.all, id] as const,
};
